class DlFaqProduct extends HTMLElement {
    constructor() {
        super();
        this.ol = this.querySelector('.dl-faq-product-ol');
        this.productTypes = document.querySelectorAll('.dl-faq-product-content-type');
        this.productTypesContainer = this.querySelector('.dl-faq-product-content-types');
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.setContainerHeight();
        this.ol.querySelectorAll('li').forEach((li, index) => {
            li.addEventListener('click', this.handleProductClick.bind(this, index))
        });
        window.addEventListener('resize', this.resize.bind(this));
    }

    handleProductClick(index, e) {
        const target = e.target;
        const parent = target.closest('li');
        // 移除同级别的li的active类
        parent.closest('ol').querySelectorAll('li').forEach(li => {
            li.classList.remove('dl-faq-product-li-active');
        });
        parent.classList.add('dl-faq-product-li-active');
        // 根据点击的li的索引index切换显示不同的产品类型
        this.productTypes.forEach((type, k) => {
            if (k === index) {
                type.classList.add('dl-show');
                this.setContainerHeight();
            } else {
                type.classList.remove('dl-show')
            }
        });
    }

    setContainerHeight() {
        let showingType = this.querySelector('.dl-faq-product-content-type.dl-show')
        if (showingType) {
            this.productTypesContainer.style.setProperty('--dl-type-height', `${showingType.offsetHeight}px`);
        }
    }
    
    resize() {
        if (this.resizing) {
            clearTimeout(this.resizing);
        }
        this.resizing = setTimeout(() => {
            this.resizing = null;
            this.setContainerHeight();
        }, 100);
    }
}
customElements.define('dl-faq-product', DlFaqProduct);